import React from "react";
import { SiTicktick } from "react-icons/si";
import cover from "../../assets/parinday/cover.webp";
import img1 from "../../assets/parinday/1.webp";
import img2 from "../../assets/parinday/2.webp";
import img3 from "../../assets/parinday/3.webp";
import img4 from "../../assets/parinday/4.webp";
import img5 from "../../assets/parinday/5.webp";
import img6 from "../../assets/parinday/6.webp";

const cards = [
  {
    title: "Menstrual Awareness",
    point1: "Breaks taboos through open dialogue",
    point2: "Promotes hygiene and product accessibility",
    point3: "Educates all genders for inclusivity",
    image: img1,
  },
  {
    title: "Gender Sensitisation",
    point1: "Challenges stereotypes and biases",
    point2: "Encourages respectful interactions",
    point3: "Fosters equality in schools and communities",
    image: img2,
  },
  {
    title: "Sex Education",
    point1: "Age-appropriate, fact-based sessions",
    point2: "Focuses on consent and boundaries",
    point3: "Covers reproductive and emotional health",
    image: img3,
  },
  {
    title: "Breast & Cervical Cancer Awareness",
    point1: "Early detection and screening advocacy",
    point2: "Self-examination techniques taught",
    point3: "Links to medical support and counseling",
    image: img4,
  },
  {
    title: "Self-Defence Training",
    point1: "Builds confidence & safety skills",
    point2: "Practical techniques for real-life situations",
    point3: "Encourages reporting and resilience",
    image: img5,
  },
  {
    title: "PCOD & PCOS Awareness",
    point1: "Simplifies medical understanding",
    point2: "Promotes lifestyle and health management",
    point3: "Connects girls with healthcare experts",
    image: img6,
  },
];

export default function Cards() {
  return (
    <div className="bg-[#e3686a] pt-8">
      <div className="w-full flex justify-center mb-[-40px] sm:mb-[-60px]">
        <img
          src={cover}
          alt="Cover"
          className="w-48 sm:w-64 md:w-72 lg:w-80 max-w-full"
        />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4 sm:px-6 lg:px-12 py-10">
        {cards.map((card, index) => (
          <div
            key={index}
            className="shadow-lg hover:shadow-xl transition-shadow duration-300 p-5 sm:p-6 rounded-xl bg-white text-[#257377] font-semibold relative border border-b-8 border-b-[#F5BB33] flex flex-col"
          >
            <img
              src={card.image}
              alt={card.title}
              className="w-14 h-14 hidden md:block md:absolute top-4 right-4"
            />
            <h2 className="text-lg font-bold mb-3 text-gray-700">
              {card.title}
            </h2>
            <ul className="space-y-2 text-gray-600">
              {[card.point1, card.point2, card.point3].map((point, i) => (
                <li key={i} className="flex items-start">
                  <SiTicktick className="text-green-600 mr-2 mt-1" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
